export const GET_ACCOUNTS = "getAccounts"
export const CREATE_ACCOUNT = "createAccount"
export const UPDATE_ACCOUNT = "updateAccount"
export const DELETE_ACCOUNT = "deleteAccount"